import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GridColDef, GridPinnedColumnFields } from '@mui/x-data-grid-pro';
import { ColumnDensity } from '@common/types';

export type PersistedReportColumn = Pick<
  GridColDef,
  | 'field'
  | 'headerName'
  | 'width'
  | 'minWidth'
  | 'flex'
  | 'sortable'
  | 'filterable'
  | 'disableColumnMenu'
  | 'align'
  | 'headerAlign'
>;

export const initialReportColumns: PersistedReportColumn[] = [
  {
    field: 'favorite',
    headerName: '',
    width: 60,
    minWidth: 60,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'name',
    headerName: 'Name',
    minWidth: 200,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'description',
    headerName: 'Description',
    minWidth: 200,
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    field: 'folder_name',
    headerName: 'Folder',
    minWidth: 160,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'organisation',
    headerName: 'Organization',
    minWidth: 160,
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    minWidth: 160,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'private',
    headerName: '',
    width: 60,
    minWidth: 60,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'action',
    headerName: '',
    width: 60,
    minWidth: 60,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
];

export const initialReportPinnedColumns: GridPinnedColumnFields = {
  left: [],
  right: [],
};

interface IReportTableDataGridStore {
  columns: PersistedReportColumn[];
  setColumns: (columns: PersistedReportColumn[]) => void;
  pinnedColumns: GridPinnedColumnFields;
  setPinnedColumns: (pinnedColumns: GridPinnedColumnFields) => void;
  hiddenColumns: string[];
  setHiddenColumns: (hiddenColumns: string[]) => void;
  density: ColumnDensity;
  setDensity: (density: ColumnDensity) => void;
  resetView: () => void;
}

export const useReportTableDataGridStore = create<IReportTableDataGridStore>()(
  persist(
    set => ({
      columns: initialReportColumns,
      setColumns: columns => set({ columns }),
      pinnedColumns: initialReportPinnedColumns,
      setPinnedColumns: pinnedColumns => set({ pinnedColumns }),
      hiddenColumns: [],
      setHiddenColumns: hiddenColumns => set({ hiddenColumns }),
      density: 'comfortable',
      setDensity: density => set({ density }),
      resetView: () =>
        set({
          columns: initialReportColumns,
          pinnedColumns: initialReportPinnedColumns,
          hiddenColumns: [],
          density: 'comfortable',
        }),
    }),
    {
      name: 'report-table-datagrid-store',
      partialize: state => ({
        columns: state.columns,
        pinnedColumns: state.pinnedColumns,
        hiddenColumns: state.hiddenColumns,
        density: state.density,
      }),
    },
  ),
);
